import { render, staticRenderFns } from "./InteractiveFramework.vue?vue&type=template&id=23e74f5e&scoped=true&"
import script from "./InteractiveFramework.vue?vue&type=script&lang=js&"
export * from "./InteractiveFramework.vue?vue&type=script&lang=js&"
import style0 from "./InteractiveFramework.vue?vue&type=style&index=0&id=23e74f5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e74f5e",
  null
  
)

export default component.exports